import { CSSObject } from "@emotion/react";

import { ICON_DEFAULT_STYLE } from "@/shared";

import { colors } from "@dotnet/telematics-design-system";

export const useStyles = () =>
  ({
    paperBox: {
      borderRadius: "8px",
      padding: "16px",
      border: `1px solid ${colors.gray300}`,
      color: colors.textSecondary
    },
    boxTitleArea: {
      marginBottom: "10px",
      color: colors.textSecondary
    },
    errorIconStyles: {
      ...ICON_DEFAULT_STYLE,
      color: colors.red700,
      margin: "2px 4px 0 0",
      alignSelf: "flex-start"
    }
  }) as CSSObject;
